import React, { useContext, useEffect, useState } from "react";
import {Box, Button, Typography} from "@material-ui/core";

import { CuratorListingContext } from "core/context/admin/curator-listing";
import { GalleryTypeEnum } from "components/Gallery/helpers/GalleryTypeEnum";

import { Loader} from "components/_others";
import { Gallery } from "components/Gallery";
import { Searchbox } from "components/_dashboard/Searchbox/Searchbox";
import { UserRoles } from "core/enums";
import { InviteUsersModal } from "components/_dashboard/InviteUsersModal";
import {getCurrentPageFromUrl} from "../../../../../core/helpers/utils";
import {useHistory} from "react-router-dom";
import {AppRoutes} from "../../../../../core/helpers";
import {UtilsContext} from "../../../../../core/context/utils.context";
import {AdminUsersApi} from "../../../../../core/api/admin-users.api";

export const CuratorListing: React.FC = () => {

    const history = useHistory();

    const curatorListingContext = useContext(CuratorListingContext);

    const [displayInviteModal, toggleInviteModal] = useState(false);
    const utilsContext = useContext(UtilsContext);    const [searchBy, setSearchBy] = useState('');

    useEffect(() => {
        const page = getCurrentPageFromUrl();
        curatorListingContext.setCurrentPage(page);
        getCurators(page, '');
    }, [])

    const getCurators = (page: number, searchBy: string): void => {
        curatorListingContext.setLoading(true);

        AdminUsersApi.getCurators(curatorListingContext.pagination.size, page, searchBy)
            .then((res: any) => {
                curatorListingContext.setCurators(res.data);
                window.scrollTo(0, 0);
            })
            .catch((error: any) => {
                console.error(error.response);
                utilsContext.addSnackbar('error');
            })
    }

    const handlePageChange = (page: number, searchBy: string): void => {
        history.push(`${AppRoutes.CURATOR_LISTING}?page=${page}`);
        curatorListingContext.setCurrentPage(page);
        getCurators(page, searchBy);
    }

    return (
        <Box>
            {
                !curatorListingContext.isLoading &&
                <>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Box>
                            <Typography variant="h5" color="textPrimary">
                                Curators
                            </Typography>
                            <Typography variant="h5" color="textSecondary" style={{fontSize: 16}}>
                                {curatorListingContext.statistics.totalUsers}
                            </Typography>
                        </Box>
                        <Box display={'flex'} alignItems={'center'}>
                            <Button
                                id="delete-btn"
                                variant="contained"
                                color="primary"
                                size={"small"}
                                onClick={() => toggleInviteModal(true)}
                            >
                                Invite Curators
                            </Button>

                            <Searchbox
                                searchBy={searchBy}
                                setSearchBy={(val: string) => setSearchBy(val)}
                                onClear={() => {
                                    setSearchBy('');
                                    handlePageChange(1, '');
                                }}
                                onSearch={(val: string) => val && val.length > 3
                                    ? handlePageChange(1, val)
                                    : handlePageChange(1, '')
                                }
                            />
                        </Box>
                    </Box>

                    <Box marginTop={'15px'}>
                        <Gallery
                            galleryType={GalleryTypeEnum.Curators}
                            data={curatorListingContext.curators}
                            pagination={{
                                numberOfPages: curatorListingContext.pagination.numberOfPages,
                                currentPage: curatorListingContext.pagination.page,
                            }}
                            handlePageChange={(page: number) => handlePageChange(page, searchBy)}
                        />
                    </Box>

                    {
                        curatorListingContext.displayEmptyPage &&
                        <Typography variant="h5" color="textSecondary" style={{fontSize: 16}}>
                            This list is empty.
                        </Typography>
                    }

                </>
            }

            {
                curatorListingContext.isLoading &&
                <Loader />
            }

            <InviteUsersModal
                open={displayInviteModal}
                role={UserRoles.CURATOR}
                handleClose={() => toggleInviteModal(false)}
            />
        </Box>
    )
}
